import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { Help } from '../../models/help';
import { withHelpSelectors } from './help.selectors';
import { withLogging } from '../features/logger.feature';
import { HelpService } from '../../services/help/help.service';
import { hasOverlap } from '../../utility/array.utility';

export type HelpState = BaseState<Help>;

export const initialState: HelpState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Help',
  entityLabel: 'Hilfe',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const HelpStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Help>(HelpService),
  withLogging(initialState.entityType),
  withHelpSelectors(),
  withMethods(store => ({
    setActiveHelpKey(key: string | undefined) {
      patchState(store, { selectedId: key });
    },
    setByKeywords(keys: string[] | null) {
      if (!keys) {
        patchState(store, { selection: [] });
      } else {
        const all = store.items();
        const newSelection: Help[] = [];
        for (const id in all) {
          const item = all[id];
          if (!item.keywords) continue;
          if (hasOverlap(item.keywords, keys)) {
            newSelection.push(item);
          }
        }
        patchState(store, { selection: newSelection });
      }
    },
  })),
  withHooks({
    onInit({ loadAllItemsByPromise }) {
      loadAllItemsByPromise();
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
